import LayoutBasic from '@/components/LayoutBasic/LayoutBasic.vue'
import { JSConn } from '@/utilities/js-conn.js'
import { TOAST_DURATION } from '@/constants'
import * as R from 'ramda'

export default {
  name: 'CropEditForm',
  components: {
    LayoutBasic
  },
  props: ['id'],
  data () {
    return {
      cropEditItem: null,
      mode: 'edit'
    }
  },
  created () {
    if (this.id === 'new') {
      this.mode = 'new'
      this.cropEditItem = {
        description: null,
        expenseCustomRateItems: [],
        expenseChemicalItems: [],
        expenseFertilizerItems: [],
        expenseSeedItems: [],
        expenseOtherExpenseItems: [],
        expenseIrrigationItems: [],
        incomeCommodityItems: [],
        incomeOtherIncomeItems: []
      }
    } else {
      this.mode = 'edit'
      const item = this.$store.getters.getCropById(this.id)
      // just want a local copy for the form
      // using the clone method from Ramda because a deep clone is necessary
      this.cropEditItem = R.clone(item)
    }
  },

  methods: {
    submitForm (evt) {
      evt.preventDefault()

      const jsConn = new JSConn()
      jsConn.toRoutePath = '/crops'

      jsConn.formParams = {
        id: this.id,
        item: this.cropEditItem
      }

      this.$store.dispatch('updateCropItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
          this.$router.push(jsConn.toRoutePath)
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    }
  }
}
